<template>
  <div>
    <router-link
      v-if="isNativeVideoLink(url) && resourceTranslations.length < 2"
      :to="`/resources/video/${slug}?timestamp=${videoTime}`"
    >
      <ResourceCardThumbnail
        :image-url="imageUrl"
        :type="type"
        :duration="duration"
        :slug="slug"
        :tag-slug="tagSlug"
      />
    </router-link>

    <div
      v-if="isNativeVideoLink(url) && resourceTranslations.length < 2"
      class="bg-gray-200 rounded-full h-1.5 dark:bg-gray-700 mt-[8px] mx-3"
    >
      <div
        class="bg-red-500 h-1.5 rounded-full"
        :style="{ width: Math.min(Math.max(videoProgess, 0), 100) + '%' }"
      ></div>
    </div>

    <VideoTag
      class="mt-[8px]"
      :is-video="type === 'video'"
      :is-exclusive="isExclusive"
      :is-audio="isAudio"
      :translations="resourceTranslations"
      :type="type"
      :currentVideoStauts="currentVideoStauts"
    />

    <p
      v-if="isNativeVideoLink(url) && resourceTranslations.length < 2"
      class="text-[16px] leading-[20px] font-bold font-aktiv-grotesk mt-[10px]"
    >
      {{ title }}
    </p>

    <p
      v-if="isNativeVideoLink(url) && resourceTranslations.length < 2"
      class="text-[16px] leading-[20px] font-medium font-aktiv-grotesk mt-[8px] text-[#4D5766]"
    >
      {{ preacher }}
    </p>
  </div>
</template>

<script>
import VideoTag from '@/components/HomePage/MustwatchSection/VideoTag.vue';
import ResourceCardThumbnail from '@/components/HomePage/MustwatchSection/ResourceCardThumbnail.vue';
import { isYoutubeLink, getYoutubeId } from '@/utils/youtube';

export default {
  components: { VideoTag, ResourceCardThumbnail },
  props: {
    imageUrl: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
    slug: {
      type: String,
      required: true,
    },
    type: {
      type: String,
      required: true,
    },
    isExclusive: {
      type: Boolean,
      default: false,
    },
    isAudio: {
      type: Boolean,
      default: false,
    },
    availTranslations: {
      type: Object,
      required: false,
      default: () => {},
    },
    resourceTranslations: {
      type: Array,
      default: () => [],
    },
    duration: {
      type: String,
      required: false,
      default: '0:00',
    },
    code: {
      type: String,
      required: false,
      default: '',
    },
    tagSlug: {
      type: String,
      default: '',
    },
    videoProgess: {
      type: Number,
      default: 0,
    },
    videoTime: {
      type: String,
      default: '',
    },
    preacher: {
      type: String,
      default: '',
    },
  },
  computed: {
    url() {
      if (this.resourceTranslations) {
        return this.resourceTranslations[0].resourceUrl;
      }
      return '';
    },
    currentVideoStauts() {
      if (this.videoProgess > 0 && this.videoProgess < 100) {
        return 'In Progress';
      } else if (this.videoProgess === 0) {
        return 'Not Started';
      } else {
        return 'Completed';
      }
    },
  },
  methods: {
    getYoutubeId,
    isNativeVideoLink(url) {
      return this.type === 'video' && !isYoutubeLink(url);
    },
  },
};
</script>
